<section class="starter-block">
  <div class="starter-block-header-wrap">
    <div class="header-title-wrap">
      <h1 class="header-title">{{(userSubscription?.isDedicatedVM ? userSubscription?.presentableTitle : userSubscription?.title) + (userSubscription?.category === UserSubscriptionCategory?.PROFESSIONAl ? ' Professional' : '')}}</h1>
      <p class="header-subtitle">
        {{subtitle}}
      </p>

    </div>
    <ng-container *ngIf="!userSubscription?.trialClient">
      <div class="db-add-website-wrap">
        <!--<ng-container *ngIf="!userSubscription?.isDedicatedVM && !userSubscription?.freeBaseClient">
          <a class="ds-btn-white-gray-border"
             [style.width]="'164px'"
             *ngIf="!userSubscription?.recharge"
             (click)="addWebsite()"
             [ngClass]="{'ds-btn-disabled': isDisabled}">
            <span>Buy additional website</span>
          </a>
        </ng-container>-->
        <ng-container *ngIf="(hasUpgrade && !upgradeLimitPassed)">
          <a class="ds-btn-blue"
             (click)="unpause.emit(true)"
             *ngIf="userSubscription?.paused">
            <span>Unpause</span>
          </a>
          <a class="ds-btn-black"
             [ngClass]="{'ds-btn-disabled': isDisabled}"
             (click)="onUpgradeClick.emit()"
             *ngIf="userSubscription?.isDedicatedVM">
            <span>Upgrade</span>
          </a>
        </ng-container>
      </div>
    </ng-container>
  </div>
  <div class="starter-block-stats" [class.has-many-stats]="getVisibleStatsCount() > 4">
    <ng-container *ngIf="!userSubscription?.trialClient;else freePlan">
      <div class="stat-body">
        <p class="stat-label">
            {{ 'text_sideBarWebsites' | dbText}}
        </p>
        <db-progress-bar
          class="mt10"
          size="sm"
          [state]="'black'"
          [class.progress-full]="websitesInfo?.percent == 100"
          [progressPercent]="websitesInfo?.percent > 100 ? 100: websitesInfo?.percent">
        </db-progress-bar>
        <div class="numbers-container">
          <p class="stat-numbers"><span class="black">{{websitesInfo?.real}}</span>/{{websitesInfo?.total}}</p>
          <!--<a (click)="addWebsite()"
             class="db-actions-wrap-enterprise db-link"
             [ngClass]="{'ds-btn-disabled': isDisabled}"
             *ngIf="(websitesInfo?.percent == 100 && !userSubscription?.recharge && !userSubscription?.apiResellerPro)
             || (websitesInfo?.percent == 100 && !userSubscription?.recharge && userSubscription?.apiResellerPro &&
             extraWebsitesInfo?.percent == 100)">
            <span>Add a Website</span>
          </a>-->
        </div>
      </div>
            <div class="stat-body">
                <p class="stat-label">
                    {{ 'text_availableCredits' | dbText}}
                </p>
                <db-progress-bar
                        class="mt10"
                        size="sm"
                        [state]="'black'"
                        [class.progress-full]="vibeCodingInfo?.percent == 100"
                        [class.progress-overload]="vibeCodingInfo?.percent > 100"
                        [progressPercent]="vibeCodingInfo?.totalAdditionalCredits >= vibeCodingInfo?.real ? 0 : (vibeCodingInfo?.percent > 100 ? 100 : vibeCodingInfo?.percent)">
                </db-progress-bar>
                <div class="numbers-container">
                    <p class="stat-numbers">
            <span class="black"
                  [innerHTML]="(userSubscription?.isExpired || userSubscription?.recharge) ? '- -' : (vibeCodingInfo?.totalAdditionalCredits >= vibeCodingInfo?.real ? '0' : vibeCodingInfo?.real)"></span>
                        /
                        <span [innerHTML]="userSubscription?.paidClient ? vibeCodingInfo?.total : (+vibeCodingInfo?.total + +vibeCodingInfo?.totalAdditionalCredits)"></span>
                    </p>
                </div>
            </div>
            <div class="stat-body">
                <p class="stat-label">
                    {{ 'text_numberOfGenerations' | dbText}}
                </p>
                <db-progress-bar
                        class="mt10"
                        size="sm"
                        [state]="'black'"
                        [class.progress-full]="vibeCodingInfo?.createdPercent"
                        [progressPercent]="vibeCodingInfo?.createdPercent > 100 ? 100: vibeCodingInfo?.createdPercent">
                </db-progress-bar>
                <div class="numbers-container">
                    <p class="stat-numbers {{userSubscription?.availableBuilder}}"><span
                            class="black">{{ (vibeCodingInfo?.createdReal) | showMinimum:  vibeCodingInfo?.createdTotal}}</span>/{{vibeCodingInfo?.createdTotal }}
                    </p>
                </div>
            </div>
    </ng-container>
    <ng-template #freePlan>
      <div class="stat-body">
        <p class="stat-label">
            {{ 'text_sideBarWebsites' | dbText}}
        </p>
        <db-progress-bar
          class="mt10"
          size="sm"
          [state]="'black'"
          [class.progress-full]="websitesInfo?.percent == 100"
          [progressPercent]="websitesInfo?.percent > 100 ? 100 : websitesInfo?.percent">
        </db-progress-bar>
        <div class="numbers-container">
          <p class="stat-numbers"><span class="black">{{websitesInfo?.real}}</span>/{{websitesInfo?.total}}</p>
        </div>
      </div>
    </ng-template>
  </div>
</section>
<!--
<ng-template #additionalTooltip>
  <div class="additional-tooltip">
    <p>You will get:</p>
    <ul>
      <li>
        <i class="db-icon db-icon-circle-sm"></i><span class="additional-tooltip-item">1 website</span>
      </li>
      <li>
        <i class="db-icon db-icon-circle-sm"></i>
        <span class="additional-tooltip-item">
          <span [innerHTML]="user?.hosting_services?.hosting_visits.parameter_value|count"></span> visitors
        </span>
      </li>
      <li>
        <i class="db-icon db-icon-circle-sm"></i>
        <span class="additional-tooltip-item"><span
          [innerHTML]="user?.hosting_services?.hosting_storage?.parameter_value|size:{unit:hostingStorageInfo?.unit}"></span> SSD storage</span>
      </li>
      <li>
        <i class="db-icon db-icon-circle-sm"></i>
        <span class="additional-tooltip-item">
          <span [innerHTML]="(backupStorageInfo?.total|size)"></span> Backup storage
        </span>
      </li>
    </ul>
  </div>
</ng-template>
-->
